<template>
  <div>
    <form @submit.prevent="handleSubmit">
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="old_date_end">Data de término da agenda atual <span class="text-danger">*</span></label>
          <input
            type="date"
            class="form-control"
            id="old_date_end"
            v-model="formData.old_date_end"
            required
          />
          <small class="form-text text-muted">
            Data em que a agenda atual será encerrada
          </small>
        </div>
        <div class="form-group col-md-6">
          <label for="new_date_start">Nova data de início <span class="text-danger">*</span></label>
          <input
            type="date"
            class="form-control"
            id="new_date_start"
            v-model="formData.new_date_start"
            required
          />
          <small class="form-text text-muted">
            Data para o novo agendamento
          </small>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="new_time_start">Nova hora de início <span class="text-danger">*</span></label>
          <input
            type="time"
            class="form-control"
            id="new_time_start"
            v-model="formData.new_time_start"
            required
          />
        </div>
        <div class="form-group col-md-6">
          <label for="new_time_end">Nova hora de término <span class="text-danger">*</span></label>
          <input
            type="time"
            class="form-control"
            id="new_time_end"
            v-model="formData.new_time_end"
            required
          />
        </div>
      </div>

      <div class="form-row mt-3">
        <div class="col-md-12">
          <div class="alert alert-info" role="alert">
            <i class="ri-information-line"></i>
            <strong>Informação:</strong> Esta solicitação será enviada para aprovação do atendente.
            Você será notificado quando a solicitação for processada.
          </div>
        </div>
      </div>

      <div class="form-row mt-3">
        <div class="col-md-12 text-right">
          <button type="button" class="btn btn-secondary mr-2" @click="handleCancel">
            Cancelar
          </button>
          <button type="submit" class="btn btn-primary" :disabled="submitting">
            <span v-if="submitting" class="spinner-border spinner-border-sm mr-2" role="status"></span>
            <span v-else><i class="ri-send-plane-line mr-1"></i></span>
            {{ submitting ? 'Enviando...' : 'Solicitar Reagendamento' }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'SchedulingRequestForm',
  props: {
    atendimentoId: {
      type: Number,
      required: true
    },
    empresaId: {
      type: Number,
      required: true
    },
    currentDate: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      formData: {
        old_date_end: '',
        new_date_start: '',
        new_time_start: '',
        new_time_end: ''
      },
      submitting: false
    };
  },
  mounted() {
    // Se currentDate foi fornecido, usar como data padrão
    if (this.currentDate) {
      this.formData.old_date_end = moment(this.currentDate).format('YYYY-MM-DD');
    } else {
      this.formData.old_date_end = moment().format('YYYY-MM-DD');
    }
  },
  methods: {
    handleSubmit() {
      // Validações básicas
      if (!this.formData.old_date_end || !this.formData.new_date_start) {
        this.$emit('error', 'Por favor, preencha todas as datas obrigatórias.');
        return;
      }

      if (!this.formData.new_time_start || !this.formData.new_time_end) {
        this.$emit('error', 'Por favor, preencha todos os horários obrigatórios.');
        return;
      }

      // Validar se nova data é posterior à data de término
      const oldDate = moment(this.formData.old_date_end);
      const newDate = moment(this.formData.new_date_start);
      
      if (newDate.isBefore(oldDate) || newDate.isSame(oldDate)) {
        this.$emit('error', 'A nova data de início deve ser posterior à data de término da agenda atual.');
        return;
      }

      // Validar se hora de término é posterior à hora de início
      const timeStart = moment(this.formData.new_time_start, 'HH:mm');
      const timeEnd = moment(this.formData.new_time_end, 'HH:mm');
      
      if (timeEnd.isBefore(timeStart) || timeEnd.isSame(timeStart)) {
        this.$emit('error', 'A hora de término deve ser posterior à hora de início.');
        return;
      }

      this.submitting = true;

      const requestData = {
        atendimento_id: this.atendimentoId,
        empresa_id: this.empresaId,
        old_date_end: this.formData.old_date_end,
        new_date_start: this.formData.new_date_start,
        new_time_start: this.formData.new_time_start,
        new_time_end: this.formData.new_time_end
      };

      this.$emit('submit', requestData);
    },
    handleCancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style scoped>
.form-group label {
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.alert {
  margin-bottom: 0;
}

.text-danger {
  color: #dc3545 !important;
}
</style>
